import { mapHoldType, mapPaginationType, useFindAllVenueHolds } from '@api';
import {
  getTableParams,
  HoldsTable,
  ManageTableProvider,
  useManageTable,
} from '@common';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.holds';

export const VenuePastHolds: React.FC = () => {
  const { t } = useTranslation('venueDetailsHolds');
  const { id } = Route.useParams();
  const { tableIdPast: tableId } = Route.useRouteContext();

  const searchParams = Route.useSearch();
  const tableParams = getTableParams(searchParams, tableId);

  const { data, isFetching } = useFindAllVenueHolds(
    id,
    {
      type: 'PAST',
      ...tableParams,
    },
    {
      query: {
        select: (response) => ({
          holds: response.data.map(mapHoldType),
          pagination: mapPaginationType(response.metadata.pagination),
        }),
      },
    }
  );

  const holds = data?.holds ?? [];
  const pagination = data?.pagination ?? mapPaginationType(undefined);

  const methods = useManageTable({
    navigateFn: Route.useNavigate(),
    searchParams,
    pagination,
    config: {},
    tableId,
  });

  return (
    <ManageTableProvider {...methods}>
      <HoldsTable
        title={t('VENUE_PAST_HOLDS.TITLE')}
        holds={holds}
        isFetching={isFetching}
        dataTestId="venue-past-holds-container"
        disabledColumns={['venue', 'city']}
      />
    </ManageTableProvider>
  );
};
